import { z } from "zod";
import { extendZodWithOpenApi } from "zod-openapi";
import { successResponse, tagPaths } from "../util.ts";
import { broken_boolean, int } from "./common.ts";

extendZodWithOpenApi(z);

export const Location = z
    .object({
        display_name: z.string(),
        description: z.string().describe("(unused in frontend)"),

        is_default: z.boolean().optional().describe("(unused in frontend)"),
        is_preferred: z.boolean().describe("This is the default location to create resources in"),
        is_published: z.boolean().optional().describe("Show this location in the frontend"),
        order_nr: int,

        slug: z
            .string()
            .describe("Code of the data center. Use this for the API location path parameter.")
            .openapi({ example: "sgp01" }),
        country_code: z.string().describe("ISO 3166-1 alpha-3").length(3).openapi({ example: "sgp" }),

        create_resource_disabled: broken_boolean
            .optional()
            .describe("New resources cannot be created in this location"),
        /** @deprecated Kept for backward compatibility; unused in frontend */
        mikrotik: broken_boolean.optional(),
        // XXX: Should this be exposed to the user?
        consul_name_override: z.string().optional(),
    })
    .openapi({ ref: "Location" });

export const LocationListResponse = z.array(Location);

export const locationPaths = tagPaths("location")({
    "/config/locations": {
        get: {
            summary: "List locations",
            responses: {
                ...successResponse(LocationListResponse),
            },
        },
    },
});
